import { useMemo } from 'react'
import moment from 'moment'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import usePackageStatusCreditsCalculation from 'loyalty/hooks/usePackageStatusCreditsCalculation'
import useHotelTierProgressionEligibility from 'loyalty/hooks/useHotelTierProgressionEligibility'
import RateTierProgressionCallOutBanner from 'loyalty/components/Banners/RateTierProgressionCallOutBanner'

interface Props {
  offer: App.HotelOffer
  packageView: App.OfferPackageOptionView
  checkIn?: string
  duration: number
  hasLoyaltyAccount: boolean
}

function OfferPageTierProgressionCallOutBanner({ offer, packageView, checkIn, duration, hasLoyaltyAccount }: Props) {
  const checkOutMoment = useMemo(() => checkIn ? moment(checkIn).add(duration, 'days') : undefined, [checkIn, duration])

  const { statusCredits: packageStatusCredits, isLoading: statusCreditsLoading } = usePackageStatusCreditsCalculation({
    offer,
    packageView,
    nights: duration,
    skip: !hasLoyaltyAccount,
  })

  const {
    showTierProgressionBanner,
    highestUnlockableTier,
    highestUnlockableTierName,
    isLoading,
  } = useHotelTierProgressionEligibility({
    statusCredits: packageStatusCredits,
    nights: duration,
    checkoutDate: checkOutMoment?.format('YYYY-MM-DD'),
    skip: !hasLoyaltyAccount || statusCreditsLoading,
  })

  if (isLoading || !showTierProgressionBanner || !highestUnlockableTier) return null

  return (
    <RateTierProgressionCallOutBanner
      highestUnlockableTier={highestUnlockableTier}
      highestUnlockableTierName={highestUnlockableTierName}
      checkoutDate={checkOutMoment?.format('YYYY-MM-DD')}
    />
  )
}

export default withMountGuard(() => useAppSelector(getIsCurrentRegionUserLoyaltyRegion))(
  OfferPageTierProgressionCallOutBanner,
)
